// src/modules/app-views/serviceOrders/pages/Init/actions/actionButton.js

import { PlusOutlined } from '@ant-design/icons';
import useZustand from 'hooks/useZustand';

const serviceOrdersInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_service_order',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    // Primary button handler - navigation to add new document
    onClick: ({ navigate, setPage }) => {
      // Show loading page before navigation to prevent flash
      const setLoadingPageStore = useZustand('boot', 'setLoadingPage', false);
      setLoadingPageStore({ visible: true, extendedDelayToHide: 600 });

      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },

    // No dropdown for this button
    dropdownItems: [],
  };
};

export default serviceOrdersInitActionButton;
